import React from 'react';
import { InventoryStockProvider } from 'contexts/inventory-stock.context';
import InventoryStockContent from './content';

const InventoryStockLayout = () => {
  return (
    <InventoryStockProvider>
      <InventoryStockContent />
    </InventoryStockProvider>
  );
};

export default InventoryStockLayout;
